export const constants = {
	//Grant Permissions
	ENTITY_TYPE_ID_PERSON: 4,
	ENTITY_TYPE_ID_TEAM: 5,
	ENTITY_TYPE_ID_ASSETDEVICE: 6,
	ENTITY_TYPE_ID_ASSETGROUP: 7,
	//Asset Group Types
	GENERAL: 1,
	ACCESS_CONTROL: 2,
	INNER_RANGE: 3,
	//Default Category
	/*
	 * List of default categories
	 */
	HEALTH_SAFETY: 1,
	SMART_LOCKS: 12,
	SMART_GATEWAYS: 13,
	SMART_LOCKER: 14,
	VERKADA_CAMERAS: 15,
	ZEZAMII_ACCESS: 17,
	ZEZAMII_GATEWAYS: 18,
	ZEZAMII_LOCKERS: 19,
	ADD_DEVICE_EXCLUDED_CATEGORIES: [12, 13, 14, 17, 18, 19],
	ACCESS_CONTROL_CATEGORIES: [12, 17],
	SMART_CATEGORIES: [12, 13, 14, 17, 18, 19],
	NON_EDITABLE_SMART_CATEGORIES: [12, 13, 17, 18],
	BOOKEABLE_LOCKERS: [14, 19],
	INNER_RANGE_DOORS: 20,
	INNER_RANGE_LIFTS: 21,
	INNER_RANGE_LIFTS_FLOORS: 22,

	//These categies as consideted as gateways for permissions, credentials and actions management
	GATEWAY_CATEGORIES: [13, 18],

	// These categories are considered as inner range devices for permissions, credentials and actions management
	INNER_RANGE_DEVICE_CATEGORIES: [20, 21, 22],

	// These categories are considered as control devices for permission, credential and action management
	CONTROL_DEVICE_CATEGORIES: [12, 14, 17, 19],

	/*
	 * Permission Manageable Categories
	 * These categories allow permission management for devices and device groups.
	 * Used for filtering which devices/groups can have permissions assigned.
	 */
	PERMISSION_MANAGEABLE_CATEGORIES: [12, 17, 20, 21, 22],

	/*
	 * Smart Categories
	 * These categories are considered as smart categories. (locker, lock, gateway)
	 * Smart categories cannot modify the additional fields by user.
	 */
	ACTIONABLE_SMART_LOCKS: [12, 14, 17, 19],
	/*
	 * Actionable Smart Locks
	 * These category will show the action for unlock or lock the smart categories (locker, lock, gateway)
	 */

	UNLOCK_CATEGORIES: [12, 14, 17, 19, 20],

	VIDEO_FIELD_TYPE_ID: 5
};
